export default __webpack_public_path__ + "static/1-418a9fd9120cc024cb8fb35a54d3efd4.png";